export const LearningPathCardVariants = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
  LIST: 'list',
} as const;

export const LearningPathCardVerticalDimensions = {
  width: 270,
  height: 360,
  coverImageWidth: 190,
  coverImageHeight: 190,
} as const;

export const LearningPathCardHorizontalDimensions = {
  height: 176,
  heightLarge: 264,
  coverImageWidth: 100,
  coverImageHeight: 100,
  coverImageWidthLarge: 200,
  coverImageHeightLarge: 200,
} as const;

export const LearningPathCardListDimensions = {
  height: 88,
  coverImageWidth: 72,
  coverImageHeight: 72,
} as const;

export const LearningPathCardDimensions = {
  [LearningPathCardVariants.VERTICAL]: LearningPathCardVerticalDimensions,
  [LearningPathCardVariants.HORIZONTAL]: LearningPathCardHorizontalDimensions,
  [LearningPathCardVariants.LIST]: LearningPathCardListDimensions,
} as const;
